import type { OfficeListResponse } from "./types/office-list-item";
import type { OfficeSearchParams } from "./types/office-search-params";

import { buildOfficeSearchUrl } from "./build-office-search-url";
import { getMarketingApiConfig } from "./get-marketing-api-config";
import { marketingApiGet } from "./marketing-api-get";

type SearchHiringOfficesOptions = {
  throwOnError?: boolean;
};

async function searchHiringOffices(
  params: OfficeSearchParams,
  options: SearchHiringOfficesOptions = {},
): Promise<OfficeListResponse> {
  const trimmedTerm = params.geoSearchTerm.trim();
  if (!trimmedTerm) {
    return { offices: [] };
  }

  const { url } = getMarketingApiConfig();

  return marketingApiGet<OfficeListResponse>({
    emptyValue: { offices: [] },
    logContext: { geoSearchTerm: trimmedTerm },
    logMessage: "Failed to fetch hiring offices from hi-marketing-api",
    mapResponse: (response) =>
      (response as OfficeListResponse | null) ?? { offices: [] },
    throwOnError: options.throwOnError,
    url: buildOfficeSearchUrl(url, "hiring", {
      ...params,
      geoSearchTerm: trimmedTerm,
    }),
  });
}

export { searchHiringOffices };
